import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useMerchants } from '@/api/queries';
import { Empty, ErrorBox } from '@/components/empty';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/_authed/gateways')({
  component: GatewaysIndex,
});

function GatewaysIndex() {
  const { t } = useTranslation();
  const m = useMerchants();
  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{t('nav.gateways')}</h1>
        <p className="text-sm text-muted-foreground">{t('merchants.pick_merchant')}</p>
      </header>

      {m.isError && <ErrorBox message={t('common.error')} />}

      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {m.data?.map((row) => (
          <Link
            key={row.id}
            to="/merchants/$merchantId"
            params={{ merchantId: row.id }}
            className="contents"
          >
            <Card className="hover:border-foreground/30 transition-colors cursor-pointer">
              <CardHeader>
                <CardTitle>{row.name}</CardTitle>
                <CardDescription className="font-mono text-xs">{row.code}</CardDescription>
              </CardHeader>
              <CardContent className="text-xs text-muted-foreground">
                {t('merchants.gateways_tab')} →
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
      {!m.isLoading && m.data?.length === 0 && <Empty title={t('merchants.none')} />}
    </div>
  );
}
